import { Controller } from "@hotwired/stimulus";

// Le partage du code d'apport — `AF-01a` du prototype « Espace apporteur · interactif »,
// 2026-09-13.
//
// 🔴 **La copie part SANS le tiret.** L'écran groupe le code par quatre pour la dictée
// (« KMTR-9YD7 ») ; le code, lui, n'a pas de tiret. `ReferralCode.lookup` tolère le tiret à la
// saisie, mais un code copié se colle aussi ailleurs que dans GO4LEARN.
//
// ⚠️ **Le partage natif n'est proposé que s'il EXISTE** (`navigator.share`) : le bouton est
// rendu masqué et révélé ici. Un bouton qui ne fait rien est pire qu'une absence de bouton.
//
// ⚠️ **`<dialog>` natif pour la feuille** : Échap la ferme sans état à tenir, et le clic sur
// le fond se lit sur le `<dialog>` lui-même (le panneau intérieur l'intercepte).
export default class extends Controller {
  static targets = ["sheet", "copyLabel", "native"];
  static values = { code: String, copied: String };

  connect() {
    this.labels = this.copyLabelTargets.map((el) => el.textContent);
    if (typeof navigator.share === "function") {
      this.nativeTargets.forEach((el) => { el.hidden = false; });
    }
  }

  open() {
    if (this.hasSheetTarget && typeof this.sheetTarget.showModal === "function") {
      this.sheetTarget.showModal();
      this.sheetTarget.addEventListener("click", this.backdropClose);
    }
  }

  close() {
    if (this.hasSheetTarget && this.sheetTarget.open) this.sheetTarget.close();
  }

  backdropClose = (event) => {
    if (event.target === this.sheetTarget) this.close();
  };

  async copy() {
    try {
      await navigator.clipboard.writeText(this.codeValue);
      this.copyLabelTargets.forEach((el) => { el.textContent = this.copiedValue; });
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.copyLabelTargets.forEach((el, i) => { el.textContent = this.labels[i]; });
      }, 2200);
    } catch (_error) {
      // ⚠️ Sans presse-papiers (contexte non sécurisé), le code reste SÉLECTIONNABLE à l'écran :
      // rien n'est perdu, et on n'annonce pas « Copié » sur une copie qui n'a pas eu lieu.
    }
  }

  async share() {
    try {
      await navigator.share({ text: this.codeValue });
    } catch (_error) {
      // L'utilisateur a refermé la feuille du système : ce n'est pas une erreur.
    }
  }

  disconnect() {
    clearTimeout(this.timer);
    if (this.hasSheetTarget) this.sheetTarget.removeEventListener("click", this.backdropClose);
  }
}
